import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ReferenceEntityType,
  ReferenceTranslationUpdate,
  ReferenceTranslationsView,
} from '../common/ReferenceTranslations';
import { ApiServiceBase } from './ApiServiceBase';

/**
 * #178 slice F / backend #701: BFF pass-through to the reference-translation curation endpoints
 * (Carrier-admin only, the same stack as the resolution-vocabulary routes).
 *
 * Writes are validated fail-closed server-side and answer the coded 4xx contract: a language the
 * platform does not speak (`languageUnsupported`), a name outside 1–100 characters
 * (`translationNameInvalid`), an unknown entity type (`referenceTypeUnknown`) or row
 * (`categoryUnknown` / `referenceUnknown`), and — the one that is specific to this surface —
 * `languageNotEditable` for an attempt to write the source language.
 */
@Injectable({
  providedIn: 'root',
})
export class ReferenceTranslationService extends ApiServiceBase {
  protected readonly path = 'referencetranslations';

  /** All three sets, plus the language rules, in one call. */
  get(): Observable<ReferenceTranslationsView> {
    return this.http
      .get<ReferenceTranslationsView>(this.getUrl());
  }

  /**
   * Writes the named languages of one row. The map is **partial** — languages it does not name
   * are left alone — so saving a single cell is a single small write, and re-sending an unchanged
   * value is a no-op.
   */
  update(
    entityType: ReferenceEntityType,
    id: string,
    update: ReferenceTranslationUpdate,
  ): Observable<unknown> {
    return this.http
      .put(`${this.getUrl()}/${entityType}/${id}`, update);
  }
}
